import { render, staticRenderFns } from "./TotalLogoStamp.vue?vue&type=template&id=71d3a766&"
import script from "./TotalLogoStamp.vue?vue&type=script&lang=js&"
export * from "./TotalLogoStamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports